import { render, staticRenderFns } from "./k-tag-info.vue?vue&type=template&id=b3644f74&"
import script from "./k-tag-info.vue?vue&type=script&lang=ts&"
export * from "./k-tag-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports